/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import messages from 'aurora-translations';
import ADGMImage from '../../ADGMImage';
import styles from './styles';

function UserDocs(props) {
  const { classes, title, handleUpload, documents, buyerSelected, handleFileRemove } = props;

  const renderer = (name, subTitle, required = true) => {
    return (
      <div className={classes.buyerDoc}>
        <Accordion
          key={name}
          defaultExpanded
          classes={{
            expanded: classes.expandedAccordian,
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={name}
            id={name}
            className={classes.accordianTitle}
          >
            <ADGMImage name='DocumentBlack.svg' alt='document' />
            <Typography component='p'>
              {subTitle}
              {required ? <span>*</span> : <span />}
            </Typography>
          </AccordionSummary>

          <AccordionDetails className={classes.accordionDetails}>
            <div className={classes.docsFlexContainer}>
              {documents
                ?.filter(doc => {
                  return (doc.userId === buyerSelected?.userId || buyerSelected?.companyId) && doc.type === name;
                })
                .map(file => (
                  <div key={file.id} className={classNames(classes.fileFlex)}>
                    <ADGMImage name='PDF.svg' alt='pdf' />
                    <Typography component='p'>{file?.file?.name || file?.fileName}</Typography>
                    <Button onClick={() => handleFileRemove(file)}>
                      <FormattedMessage {...messages.remove} />
                    </Button>
                  </div>
                ))}
              <>
                <input
                  id={name.toLowerCase()}
                  name={name}
                  type='file'
                  accept='application/pdf'
                  hidden
                  onChange={handleUpload}
                />
                <label htmlFor={name.toLowerCase()}>
                  <Button variant='outlined' component='span' id={name} className={classes.largeButton}>
                    <ADGMImage name='uplaodIcon.svg' alt='icon' />
                    <Typography component='p'>
                      <FormattedMessage {...messages.upload_document} />
                    </Typography>
                  </Button>
                </label>
              </>
            </div>
          </AccordionDetails>
        </Accordion>
      </div>
    );
  };

  return (
    <div className={classes.docsContainer}>
      <div className={classes.panelTitle}>
        <Typography variant='h6'>{title}</Typography>
      </div>
      <>
        {renderer('PASSPORT', <FormattedMessage {...messages.passport} />)}
        {renderer('OTHERS', <FormattedMessage {...messages.OTHERS} />, false)}
      </>
    </div>
  );
}

UserDocs.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.object.isRequired,
  documents: PropTypes.array.isRequired,
  buyerSelected: PropTypes.object.isRequired,
  handleFileRemove: PropTypes.func.isRequired,
  handleUpload: PropTypes.func.isRequired,
};

UserDocs.defaultProps = {};

export default withStyles(styles)(UserDocs);
